var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { contactUsEntityName, sendAdminNotificationDef, sendAnonymousAdminNotificationDef } from '../../../../../backend/features/contact-us/shared';
import { useContactManagementTranslation } from '../../../../../ui/hooks/useContactManagementTranslation';
import { useTypedAnonymousPlatformFunctionCM } from '../../../../../ui/hooks/useTypedAnonymousPlatformFunction';
import { Form } from '@juvare/common-form-ui/Form';
import { PageError } from '@juvare/common-web-ui/PageError';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { usePublicDataGet } from '@juvare/platform-sdk-react/ui/hooks/usePublicDataGet';
import React from 'react';
export const ContactUsPanel = (props) => {
    const { t } = useContactManagementTranslation();
    const publicDataResponse = usePublicDataGet(`classifier-${contactUsEntityName}`);
    const classifier = publicDataResponse.data
        ? publicDataResponse.data.find((config) => config.anonymous === props.isAnonymous)
        : undefined;
    const sendAdminNotification = useTypedPlatformFunction(sendAdminNotificationDef);
    const sendAnonymousAdminNotification = useTypedAnonymousPlatformFunctionCM(sendAnonymousAdminNotificationDef, props.appName, contactUsEntityName);
    const [resetFormKey, setResetFormKey] = React.useState(1);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (formData) => __awaiter(void 0, void 0, void 0, function* () {
        if (props.isAnonymous) {
            yield sendAnonymousAdminNotification({ data: formData });
        }
        else {
            yield sendAdminNotification({ data: formData });
        }
        showInfoSnackbar({ message: t('contactUs.notification.messageSubmitted'), autoHideDuration: 2000 });
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnSubmitSuccess = (data, response) => {
        var _a;
        (_a = props.onAfterSubmit) === null || _a === void 0 ? void 0 : _a.call(props, data, response);
        if (props.resetFormAfterSubmit) {
            setResetFormKey((key) => key + 1);
        }
    };
    if (publicDataResponse.error) {
        return React.createElement(PageError, { error: publicDataResponse.error });
    }
    if (!(classifier === null || classifier === void 0 ? void 0 : classifier.form) && !publicDataResponse.isLoading) {
        return React.createElement(PageError, { message: t('contactUs.panel.formConfigNotFound') });
    }
    if (!(classifier === null || classifier === void 0 ? void 0 : classifier.form)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Form, { key: resetFormKey, config: classifier === null || classifier === void 0 ? void 0 : classifier.form, onSubmit: handleSubmit, onSubmitSuccess: handleOnSubmitSuccess, submitLabel: t('contactUs.notification.submitButtonLabel'), "data-test": props['data-test'] }));
};
